/**
 * Centralized Application Configuration
 * All hardcoded business constants should live here — not in component files.
 */

// ─── Tax Rates ──────────────────────────────────────────────
export const DEFAULT_TAX_RATE = 0.08        // 8% — default US sales tax
export const HOME_REPAIR_TAX_RATE = 0.0825  // 8.25% — average US rate for repair services
export const WARRANTY_TAX_RATE = 0.07       // 7% — warranty plan tax

// ─── Shipping ───────────────────────────────────────────────
export const DEFAULT_SHIPPING_COST = 9.99

// ─── Support Contacts ───────────────────────────────────────
export const SUPPORT_EMAIL = 'support@squaretrade.com'
export const SUPPORT_PHONE = '1-800-HOME-IQ'
export const WARRANTY_SUPPORT_PHONE = '1-800-SquareTrade'
export const BOOKING_SUPPORT_PHONE = '1-800-555-1234'

// ─── EMI / Financing ───────────────────────────────────────
export interface EMIOption {
  months: number
  interestRate: number
  label: string
  isAvailable: boolean
}

export const EMI_OPTIONS: EMIOption[] = [
  { months: 3,  interestRate: 0,  label: '3 months - No interest',  isAvailable: true },
  { months: 6,  interestRate: 0,  label: '6 months - No interest',  isAvailable: true },
  { months: 9,  interestRate: 12, label: '9 months - 12% APR',      isAvailable: true },
  { months: 12, interestRate: 13, label: '12 months - 13% APR',     isAvailable: true },
  { months: 18, interestRate: 14, label: '18 months - 14% APR',     isAvailable: true },
  { months: 24, interestRate: 15, label: '24 months - 15% APR',     isAvailable: true },
]

// ─── Validation ─────────────────────────────────────────────

// ─── API ────────────────────────────────────────────────────
export const API_TIMEOUT_MS = 10000

// ─── Theme Colors (semantic) ────────────────────────────────
// Use these instead of hardcoded hex colors in components
export const HEALTH_COLORS = {
  good: '#22c55e',     // green-500
  warning: '#f59e0b',  // amber-500
  critical: '#ef4444', // red-500
  inactive: '#6B7280', // gray-500
} as const

// ─── Distance Pricing ───────────────────────────────────────
export const DISTANCE_FREE_MILES = 50
export const DISTANCE_PRICE_PER_MILE = 2
export const PARTS_LABOR_RATIO = 0.4  // parts estimated at 40% of labor cost
